import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// Connects to data-controller="flatpickr-date"
// data: { controller: "flatpickr-date", "flatpickr-date-options-value": '{"enableTime": false}' }

export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    const defaultOptions = {
      locale: "en",
      enableTime: true,
      minuteIncrement: 1,
      // defaultDate: new Date().toISOString(),
      allowInput: true,
      dateFormat: "Y-m-d H:i",
      altInput: true,
      altFormat: "m/d/Y G:i K",
      onReady: (selectedDates, dateStr, instance) => {
        this._fixAltInput(instance)
      }
    }
    const mergedOptions = { ...defaultOptions, ...this.optionsValue }

    flatpickr(this.element, mergedOptions)
  }

  _fixAltInput(instance) {
    const alt = instance.altInput
    if (!alt) return

    const id = this.element.id
    if (id) {
      const label = document.querySelector(`label[for="${id}"]`)
      if (label) {
        alt.setAttribute("aria-label", label.textContent.trim())
      }
    }
  }
}
